import React from 'react';
import styled from 'styled-components';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import 'react-quill-new/dist/quill.snow.css';
import Button from 'kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';

import FleetOpsStaffOnly from '../Common/FleetOpsStaffOnly';
import Inputs from '../Inputs';
import Row from '../Common/Row';
import ReactQuill from 'react-quill-new';
// Reads (and keeps) the size a heading gives part of a line in Studio, and
// its text colours
import 'components/Studio/textSizeFormat';
import { TEXT_COLOR_CSS } from 'components/Studio/textColorFormat';

const ModalWrapper = styled.div`
  padding: 8px 16px;
`;

const ContentWrapper = styled.div`
  margin-bottom: 8px;

  ${TEXT_COLOR_CSS}
`;

const TextCardForm = ({
  text,
  onChange,
  onSave,
  isOpen,
  close,
  isCenterAlign,
  onAlignChanged,
}: {
  text: string;
  onChange: (t: string) => void;
  onSave: () => void;
  isOpen: boolean;
  close: () => void;
  isCenterAlign: boolean;
  onAlignChanged: (newAlign: boolean) => void;
}) => (
  <ModalTransition>
    {isOpen && (
      <Modal onClose={close} shouldScrollInViewport={false} autoFocus={false}>
        <ModalWrapper>
          <FleetOpsStaffOnly>
            <Row centerAlign style={{ marginBottom: 8 }}>
              <Typography.Body type="Label">Center align</Typography.Body>
              <div style={{ marginLeft: 8 }}>
                <Inputs.Checkbox
                  isChecked={isCenterAlign}
                  onToggled={onAlignChanged}
                />
              </div>
            </Row>
          </FleetOpsStaffOnly>
          <ContentWrapper>
            <ReactQuill theme="snow" value={text} onChange={onChange} />
          </ContentWrapper>
          <Row spaceBetween centerAlign style={{ marginTop: 12 }}>
            <Button onClick={close} type="Ghost" size="Small" label="Cancel" />
            <Button onClick={onSave} type="Primary" size="Small" label="Save" />
          </Row>
        </ModalWrapper>
      </Modal>
    )}
  </ModalTransition>
);

export default TextCardForm;
